import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { CommandCenterNursesRequest } from "../utils/models";

export function useCommandCenter(params: CommandCenterNursesRequest) {
	const {
		data: commandCenterNurses,
		isLoading: isGettingNurses,
		error: getNursesError,
		refetch,
	} = useQuery({
		queryKey: ["commandCenterNurses", params?.departmentId],
		queryFn: async () => {
			const response = await backendService.getCommandCenterNurses(params.departmentId);
			return response.data;
		},
		enabled: !!params?.departmentId,
		refetchOnWindowFocus: false,
	});

	return {
		commandCenterNurses,
		refetchCommandCenterNurses: refetch,
		isLoading: {
			getCommandCenterNurses: isGettingNurses,
		},
		error: {
			getCommandCenterNurses: getNursesError,
		},
	};
}
